import { PAGE_URLS } from "src/configs/pages-urls";

export const AUTH_CONSTANTS = {
	OIDC_STORAGE_PREFIX: "oidc.",
	REDIRECT_TIMEOUT: 100,
	AUTH_SUCCESS_TIMEOUT: 3000,
	MAX_RETRY_ATTEMPTS: 3,
} as const;

export const clearOidcStorage = (): void => {
	Object.keys(localStorage).forEach((key) => {
		if (key.startsWith(AUTH_CONSTANTS.OIDC_STORAGE_PREFIX)) {
			localStorage.removeItem(key);
		}
	});

	Object.keys(sessionStorage).forEach((key) => {
		if (key.startsWith(AUTH_CONSTANTS.OIDC_STORAGE_PREFIX)) {
			sessionStorage.removeItem(key);
		}
	});
};

export const unregisterServiceWorkers = async (): Promise<void> => {
	if ("serviceWorker" in navigator) {
		const registrations = await navigator.serviceWorker.getRegistrations();
		await Promise.all(
			registrations.map((registration) => registration.unregister()),
		);
	}
};

export const redirectToSignIn = (): void => {
	window.location.href = `${window.location.origin}${PAGE_URLS.signIn.path}`;
};

export const resetAuthentication = async (): Promise<void> => {
	try {
		clearOidcStorage();

		try {
			await unregisterServiceWorkers();
		} catch (error) {
			console.warn("Failed to unregister service workers:", error);
		}

		setTimeout(() => {
			redirectToSignIn();
		}, AUTH_CONSTANTS.REDIRECT_TIMEOUT);
	} catch (error) {
		console.error("Authentication reset failed:", error);
		redirectToSignIn();
	}
};

export const resetAuthenticationFallback = (): void => {
	clearOidcStorage();
	window.location.reload();
};
